import { observer } from "mobx-react-lite";
import Dialog from "@material-ui/core/Dialog";
import Backdrop from "@material-ui/core/Backdrop";
import * as React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import { useState } from "react";
import { useStyles } from "../Dialog.styles";
import { tableStore } from "../../../mobx/stores/TableStore/TableStore";
import { mailsStore } from "../../../mobx/stores/MailsStore/MailsStore";

interface DialogAutoLoginMailProps {
  onClose: () => void;
  open: boolean;
  userId: string;
}

export const DialogAutoLoginMail = observer(({ onClose, open, userId }: DialogAutoLoginMailProps) => {
  const classes = useStyles();
  const { autoLoginUrls } = tableStore;
  const { createMailTask } = mailsStore;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const autoLoginUrl = autoLoginUrls[userId];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={"body"}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <DialogTitle>
        <Grid container alignItems={"center"} justify={"space-between"}>
          <Typography variant={"h5"}>Ссылка для автологина</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Paper className={classes.paper} elevation={3}>
          <InputBase className={classes.input} readOnly value={autoLoginUrl} />
          <Divider orientation="vertical" className={classes.divider} />
          <Tooltip title={<Typography variant={"caption"}>Переслать на почту</Typography>}>
            <IconButton color="primary" className={classes.iconButton} onClick={handleSendMail}>
              <SendIcon />
            </IconButton>
          </Tooltip>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Grid container justify={"flex-end"}>
          <Button onClick={onClose} color={"primary"}>
            Закрыть
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );

  async function handleSendMail() {
    setIsLoading(true);
    await createMailTask({
      mail_template_data: {
        user_id: parseFloat(userId),
      },
      mail_template_id: 1,
    });
    setIsLoading(false);
  }
});
